const initialState = []

export const Item = (state = [], action) => {
    switch (action.type) {
        case 'FETCH_ITEM':return state = action.payload.timestamps;
        case 'RESET_ITEM':return state = action.payload.timestamps;
        default:return initialState;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/item.js